import useHasWorkspaceWithCustomBranding from 'src/new_arch/modules/workspaces/hooks/useHasWorkspaceWithCustomBranding';
import { useIsGuest } from 'src/hooks/useIsGuest';
import Project from 'src/entities/project';
import Folder from 'src/entities/folder';
import Asset from 'src/entities/asset';
import { useHistory } from 'react-router-dom';

export type BreadcrumbsConfig = {
	firstItem: { name: string; url: string } | undefined;
	showBreadcrumbs: boolean;
	hideHomeIcon: boolean;
	hideFirstArrow: boolean;
	homeIconClickable: boolean;
	customHomeLogo?: string;
};

type UseBreadcrumbsConfigProps = {
	project: Project;
	folder: Folder;
	asset: Asset;
};

const useBreadcrumbsConfig = ( {
	project,
	folder,
	asset
}: UseBreadcrumbsConfigProps ): BreadcrumbsConfig => {
	const history = useHistory();
	const hasWorkspaceWithCustomBranding = useHasWorkspaceWithCustomBranding();
	const isGuest = useIsGuest();

	const inHiddenProjects = history.location.pathname === '/hidden_projects' || project?.status === 'archived';
	const inDashboard = history.location.pathname === '/projects' || history.location.pathname === '/hidden_projects';
	const isProjectRoot = project && !folder && !asset;
	const projectHasCustomBranding = project?.workspace?.hasCustomBranding;

	const showBreadcrumbs = !isGuest || !isProjectRoot || projectHasCustomBranding;
	const hideHomeIcon = ( inDashboard && hasWorkspaceWithCustomBranding )
		|| ( isGuest && !isProjectRoot && !projectHasCustomBranding )
		|| inHiddenProjects;
	const homeIconClickable = !isGuest;
	const hideFirstArrow = hideHomeIcon || isGuest;
	const customHomeLogo = project?.workspace?.logo;
	const firstItem = inHiddenProjects ? { name: 'Hidden projects', url: '/hidden_projects' } : undefined;

	return {
		firstItem,
		showBreadcrumbs,
		hideHomeIcon,
		hideFirstArrow,
		homeIconClickable,
		customHomeLogo
	};
};

export default useBreadcrumbsConfig;
